module.exports = __webpack_public_path__ + "b68c4fb69e0df78867e278e85549da47.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-22.png
// module id = 2497
// module chunks = 0